// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"5501":"90d2c0df","6719":"1ed6fd24"}[chunkId] || chunkId) + "." + {"5501":"13ad93066d9f87b0","6719":"afdb76aaa83ab9d3","8541":"edd327a3e8f1b034","9689":"6486a2cb560dddcf"}[chunkId] + ".js";
};